import { SearchResponses, SearchResponse } from 'algoliasearch';

import { searchClient } from '@/lib/search/algolia';
import { SearchHit, SearchResults, SearchResultsByCategory } from '@/lib/models/Search';
import { INDEX_NAME, ALL_CATEGORIES, HELPDESK_CATEGORY_ALL } from '@/lib/constants/Search';

export async function fetchSearchResults(query: string, locale: string): Promise<SearchResultsByCategory> {
  if (!query?.trim()) {
    const empty: SearchResults = { hits: [], count: 0, totalPages: 0 };
    return {
      all: empty,
      knowledgebase: empty,
      documentation: empty,
      templates: empty,
    };
  }

  const baseFilter = [`language:${locale}`];

  const requests = [
    {
      indexName: INDEX_NAME,
      query,
      hitsPerPage: 20,
      page: 0,
      facetFilters: [[...baseFilter], [`objectName:${HELPDESK_CATEGORY_ALL}`]],
    },
    ...ALL_CATEGORIES.map((category) => ({
      indexName: INDEX_NAME,
      query,
      hitsPerPage: 20,
      page: 0,
      facetFilters: [[...baseFilter], [`objectType:${category}`]],
    })),
  ];

  const response: SearchResponses = await searchClient.search(requests);

  const [allResults, knowledgebaseResults, documentationResults, templatesResults] =
    response.results as unknown as SearchResponse<SearchHit>[];

  const transform = (r: SearchResponse<SearchHit>) => ({
    hits: r.hits ?? [],
    count: r.nbHits ?? 0,
    totalPages: r.nbPages ?? 0,
  });

  return {
    all: transform(allResults),
    knowledgebase: transform(knowledgebaseResults),
    documentation: transform(documentationResults),
    templates: transform(templatesResults),
  };
}
